/* James Cosmetics global collection Filter / Sort controls */
(() => {
  if (!window.location.pathname.startsWith('/collections/')) return;

  const init = () => {
    const toolbar = document.querySelector('.collection-utility, .filters-toolbar');
    const wrapper = toolbar && toolbar.querySelector('.collection-utility__controls, .filters-toolbar__item-wrapper');
    if (!toolbar || !wrapper || wrapper.querySelector('[data-james-global-controls]')) return;

    const concernChoices = [
      ['Dark Circles & Pigmentation', 'filter-dark-circles-pigmentation', 'Dark Circles'],
      ['Fine Lines & Wrinkles', 'filter-fine-lines-wrinkles', 'Fine Lines'],
      ['Puffiness & Tired Eyes', 'filter-puffiness-tired-eyes', 'Puffiness'],
      ['Dry & Dehydrated Skin', 'filter-dry-dehydrated-skin', 'Dry Skin'],
      ['Dull Skin', 'filter-dull-skin', 'Dull Skin'],
      ['Barrier Repair / Strengthening', 'filter-barrier-repair-strengthening', 'Barrier Repair'],
      ['Sensitive Skin', 'filter-sensitive-skin', 'Sensitive Skin'],
      ['Pregnancy Safe', 'filter-pregnancy-safe', 'Pregnancy Safe']
    ];
    const sortChoices = [
      ['Featured', 'manual'],
      ['Best selling', 'best-selling'],
      ['Alphabetically, A–Z', 'title-ascending'],
      ['Alphabetically, Z–A', 'title-descending'],
      ['Price, low to high', 'price-ascending'],
      ['Price, high to low', 'price-descending'],
      ['Date, old to new', 'created-ascending'],
      ['Date, new to old', 'created-descending']
    ];
    const parts = window.location.pathname.split('/').filter(Boolean);
    const collectionBase = `/${parts.slice(0, 2).join('/')}`;
    const activeConcern = parts[2] || '';
    const params = new URLSearchParams(window.location.search);
    const activeSort = params.get('sort_by') || 'manual';

    if (!document.getElementById('james-global-collection-controls-style')) {
      const style = document.createElement('style');
      style.id = 'james-global-collection-controls-style';
      style.textContent = `
        .filters-toolbar,
        .collection-utility {
          position: relative;
          z-index: 400 !important;
          overflow: visible !important;
          padding: 22px 0 !important;
          border-top: 1px solid #eee8dd !important;
          border-bottom: 1px solid #eee8dd !important;
          background: #f7f3eb !important;
        }
        .filters-toolbar__item-wrapper,
        .collection-utility__controls {
          display: block !important;
          width: 100% !important;
          max-width: 960px !important;
          margin: 0 auto !important;
          padding: 0 24px !important;
        }
        .collection-utility__inner {
          display: block !important;
          min-height: 0 !important;
          padding: 0 !important;
        }
        .filters-toolbar__item-wrapper > :not([data-james-global-controls]),
        .collection-utility__controls > :not([data-james-global-controls]),
        .filters-toolbar__item--count,
        .collection-utility__count { display: none !important; }
        .james-global-controls {
          position: relative;
          z-index: 50;
          display: flex;
          width: 100%;
          justify-content: center;
          gap: 24px;
        }
        .james-global-control {
          position: relative;
          z-index: 8;
          flex: 1 1 0;
          max-width: 420px;
        }
        .james-global-control__button {
          display: flex;
          width: 100%;
          height: 56px;
          align-items: center;
          padding: 0 24px;
          border: 1px solid #c6a55f;
          background: #fff;
          color: #171717;
          cursor: pointer;
          font: 500 12px/1 var(--font-stack-body);
          letter-spacing: .06em;
          text-transform: uppercase;
        }
        .james-global-control__primary {
          flex: 0 0 auto;
          margin-right: 22px;
          font-weight: 600;
          letter-spacing: .09em;
        }
        .james-global-control__value {
          min-width: 0;
          overflow: hidden;
          color: #6d6557;
          font-weight: 400;
          letter-spacing: .05em;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .james-global-control__chevron {
          width: 9px;
          height: 9px;
          margin-right: 2px;
          margin-left: auto;
          border-right: 1px solid #ad8536;
          border-bottom: 1px solid #ad8536;
          transform: rotate(45deg);
          transition: transform .15s ease;
        }
        .james-global-control__button[aria-expanded='true'] .james-global-control__chevron {
          transform: rotate(225deg);
        }
        .james-global-control__panel {
          position: absolute;
          z-index: 100;
          top: calc(100% + 10px);
          left: 0;
          width: min(420px, calc(100vw - 40px));
          padding: 16px;
          border: 1px solid #c6a55f;
          background: #fff;
          box-shadow: 0 12px 30px rgba(23, 23, 23, .12);
        }
        .james-global-control__panel[hidden] { display: none; }
        .james-global-control__options {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          border-top: 1px solid #e3d8c1;
          border-left: 1px solid #e3d8c1;
        }
        .james-global-control--sort .james-global-control__options {
          grid-template-columns: minmax(0, 1fr);
        }
        .james-global-control__option {
          display: flex;
          min-height: 46px;
          align-items: center;
          padding: 10px 12px;
          border-right: 1px solid #e3d8c1;
          border-bottom: 1px solid #e3d8c1;
          color: #171717;
          font: 500 12px/1.25 var(--font-stack-body);
          letter-spacing: .04em;
          text-transform: uppercase;
        }
        .james-global-control__option:hover,
        .james-global-control__option[aria-current='true'] { background: #fbf8f1; }
        .james-global-control__button:focus-visible,
        .james-global-control__option:focus-visible {
          outline: 2px solid #171717;
          outline-offset: 3px;
        }
        @media (max-width: 900px) {
          .filters-toolbar__item-wrapper,
          .collection-utility__controls { max-width: 760px !important; }
          .james-global-controls { gap: 16px; }
          .james-global-control { max-width: 360px; }
        }
        @media (max-width: 749px) {
          .filters-toolbar,
          .collection-utility { padding: 14px 0 !important; }
          .filters-toolbar__item-wrapper,
          .collection-utility__controls {
            max-width: none !important;
            padding: 0 20px !important;
          }
          .james-global-controls { gap: 8px; }
          .james-global-control { width: calc(50% - 4px); max-width: none; }
          .james-global-control__button { height: 48px; padding: 0 16px; }
          .james-global-control__primary { margin-right: 0; }
          .james-global-control__value { display: none; }
          .james-global-control__panel { width: min(330px, calc(100vw - 40px)); }
          .james-global-control--sort .james-global-control__panel { right: 0; left: auto; }
          .james-global-control__options { grid-template-columns: minmax(0, 1fr); }
        }
      `;
      document.head.appendChild(style);
    }

    const makeLink = (label, href, selected) => {
      const link = document.createElement('a');
      link.className = 'james-global-control__option';
      link.href = href;
      link.textContent = label;
      if (selected) link.setAttribute('aria-current', 'true');
      return link;
    };

    const createControl = (type, value) => {
      const root = document.createElement('div');
      const button = document.createElement('button');
      const primary = document.createElement('span');
      const valueNode = document.createElement('span');
      const chevron = document.createElement('span');
      const panel = document.createElement('div');
      const options = document.createElement('div');

      root.className = `james-global-control james-global-control--${type}`;
      button.className = 'james-global-control__button';
      button.type = 'button';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', `${type} products`);
      primary.className = 'james-global-control__primary';
      primary.textContent = type;
      valueNode.className = 'james-global-control__value';
      valueNode.textContent = value;
      chevron.className = 'james-global-control__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      panel.className = 'james-global-control__panel';
      panel.hidden = true;
      options.className = 'james-global-control__options';
      panel.appendChild(options);
      button.append(primary, valueNode, chevron);
      root.append(button, panel);

      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        document.querySelectorAll('.james-global-control__button[aria-expanded="true"]').forEach((other) => {
          if (other !== button) {
            other.setAttribute('aria-expanded', 'false');
            other.nextElementSibling.hidden = true;
          }
        });
        button.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          button.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
          button.focus();
        }
      });
      return { root, panel, options, button };
    };

    const activeConcernChoice = concernChoices.find((choice) => choice[1] === activeConcern);
    const filter = createControl('filter', activeConcernChoice ? activeConcernChoice[2] : 'All concerns');
    filter.options.appendChild(makeLink('All', `${collectionBase}${params.get('sort_by') ? `?sort_by=${encodeURIComponent(params.get('sort_by'))}` : ''}`, !activeConcern));
    concernChoices.forEach((choice) => {
      const query = params.get('sort_by') ? `?sort_by=${encodeURIComponent(params.get('sort_by'))}` : '';
      filter.options.appendChild(makeLink(choice[0], `${collectionBase}/${choice[1]}${query}`, activeConcern === choice[1]));
    });

    const activeSortChoice = sortChoices.find((choice) => choice[1] === activeSort) || sortChoices[0];
    const sort = createControl('sort', activeSortChoice[0]);
    sortChoices.forEach((choice) => {
      const sortParams = new URLSearchParams(window.location.search);
      sortParams.delete('page');
      if (choice[1] === 'manual') sortParams.delete('sort_by');
      else sortParams.set('sort_by', choice[1]);
      const query = sortParams.toString();
      sort.options.appendChild(makeLink(choice[0], `${window.location.pathname}${query ? `?${query}` : ''}`, activeSort === choice[1]));
    });

    const controls = document.createElement('div');
    controls.className = 'james-global-controls';
    controls.setAttribute('data-james-global-controls', '');
    controls.setAttribute('data-james-filter-matrix', '');
    controls.append(filter.root, sort.root);
    wrapper.prepend(controls);
    [...wrapper.children].forEach((child) => {
      if (child !== controls) child.remove();
    });

    document.addEventListener('click', (event) => {
      if (!controls.contains(event.target)) {
        controls.querySelectorAll('.james-global-control__button').forEach((button) => button.setAttribute('aria-expanded', 'false'));
        controls.querySelectorAll('.james-global-control__panel').forEach((panel) => { panel.hidden = true; });
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
